// extracted by mini-css-extract-plugin
export var dark = "ModeToggle-module--dark--6f00d";
export var darkIcon = "ModeToggle-module--darkIcon--39316";
export var lightIcon = "ModeToggle-module--lightIcon--be068";
export var mobileRevert = "ModeToggle-module--mobileRevert--10aa6";
export var root = "ModeToggle-module--root--51bf1";
export var toggle = "ModeToggle-module--toggle--c0184";